<main class="template-feature-values-mapping-popup">
  <nb-card>
    <nb-card-body>
      <div class="mapping">
        <form [formGroup]="valueMappingForm">
          <div class="mb-3">
            <ng-select [items]="featureValuesFrom"
                       [closeOnSelect]="false"
                       bindLabel="value"
                       bindValue="id"
                       (change)="onFeatureValueChoose($event)"
                       formControlName="valueChooser"
                       [multiple]="true"
                       [(ngModel)]="selected"
                       id="templateFeatureValueID"
                       placeholder="Выберите значение характеристики"
                       i18n-placeholder="@@ChooseTemplateFeatureValuePlaceholder"
            >
            </ng-select>
          </div>
          <div formArrayName="valueMappings">
            <div *ngFor="let valueMapping of mapping.controls; let i = index">
              <div [formGroup]="valueMapping" class="featureValuesMapping">
                <div class="featureValueMapping">
                  <div class="featureValueMappingFrom">
                    <ng-select [items]="featureValuesFrom"
                               bindLabel="value"
                               bindValue="id"
                               [clearable]="false"
                               [readonly]="true"
                               formControlName="sourceValueId"
                               placeholder="Выберите значение характеристики"
                               i18n-placeholder="@@ChooseTemplateFeatureValuePlaceholder"
                    >
                    </ng-select>
                  </div>
                  <div class="featureValueMappingTo">
                    <ng-select [items]="featureValuesTo"
                               bindLabel="value"
                               bindValue="id"
                               [clearable]="true"
                               formControlName="destValueId"
                               placeholder="Выберите значение характеристики"
                               i18n-placeholder="@@ChooseTemplateFeatureValuePlaceholder"
                    >
                    </ng-select>
                  </div>
                </div>

                <div class="featureValueMapping__button">
                  <button type="button" i18n-nbTooltip="@@Delete" nbTooltip="удалить" (click)="deleteValueMappingItem(i)" nbButton size="medium" status="danger">
                    <nb-icon icon="close"></nb-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton status="primary" type="button" i18n="@@Save" [disabled]="valueMappingForm.invalid" (click)="saveValueMapping()">Сохранить</button>&nbsp;
      <button nbButton status="basic" type="button" i18n="@@Close" (click)="modalClose()">Закрыть</button>
    </nb-card-footer>
  </nb-card>
</main>
